import { jsx as o } from "react/jsx-runtime";
const r = ({ size: C, className: t }) => /* @__PURE__ */ o(
  "svg",
  {
    className: t,
    fill: "none",
    height: C,
    viewBox: "0 0 16 16",
    width: C,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M9.89599 8L15.615 2.284C15.7394 2.15925 15.8381 2.0112 15.9053 1.84833C15.9725 1.68545 16.007 1.51093 16.0067 1.33474C16.0065 1.15854 15.9716 0.984107 15.9039 0.821409C15.8363 0.658711 15.7372 0.51093 15.6125 0.386502C15.4877 0.262075 15.3397 0.163438 15.1768 0.096224C15.0139 0.02901 14.8394 -0.00546475 14.6632 -0.0052326C14.487 -0.00500045 14.3126 0.0299343 14.1499 0.0975773C13.9872 0.16522 13.8394 0.264247 13.715 0.389003L7.99999 6.105L2.28499 0.389003C2.16063 0.264641 2.01299 0.165992 1.85051 0.0986874C1.68802 0.0313832 1.51387 -0.00325754 1.33799 -0.00325754C1.16212 -0.00325754 0.987967 0.0313833 0.82548 0.0986874C0.662994 0.165992 0.515355 0.26464 0.390993 0.389002C0.266631 0.513364 0.167983 0.661003 0.100678 0.823489C0.0333743 0.985976 -0.00126648 1.16013 -0.00126648 1.336C-0.00126648 1.51188 0.0333743 1.68603 0.100678 1.84852C0.167983 2.011 0.266631 2.15864 0.390993 2.283L6.10599 7.999L0.393993 13.711C0.142038 13.9622 0.000174457 14.3031 -0.000388145 14.6589C-0.000950748 15.0146 0.139833 15.356 0.390993 15.608C0.642153 15.86 0.983115 16.0018 1.33887 16.0024C1.69463 16.0029 2.03604 15.8622 2.28799 15.611L8.00299 9.895L13.715 15.611C13.9669 15.863 14.3087 16.0045 14.665 16.0045C15.0213 16.0045 15.363 15.863 15.615 15.611C15.8669 15.359 16.0085 15.0173 16.0085 14.661C16.0085 14.3047 15.8669 13.963 15.615 13.711L9.89599 8Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  r as IosClose
};
